import { createStore, applyMiddleware, combineReducers } from 'redux'
import { createEpicMiddleware, combineEpics } from 'redux-observable'
import { actressReducer } from '../ducks/actresses/reducers'
import { cardsReducer } from '../ducks/cards/reducers'
import { modalsReducer } from '../ducks/modals/reducers'
import ActressEpics from '../ducks/actresses/operations'

const epicMiddleware = createEpicMiddleware()
const epics = combineEpics(...ActressEpics)

const rootReducer = combineReducers({ cards: cardsReducer, actresses: actressReducer, modals: modalsReducer })

const configureStore = () => {
  const rootInitialState = {}

  return createStore(rootReducer, rootInitialState, applyMiddleware(epicMiddleware))
}

const store = configureStore()
epicMiddleware.run(epics)

export default store
